<template>
  <div>
    <div v-if="asyncDataStatus_ready" class="cms">
      <v-row justify="space-between">
        <v-col cols="12" sm="10" md="6">
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Od"
                :date="startDate"
                :time="startTime"
                @change="updateStartDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Do"
                :date="endDate"
                :time="endTime"
                @change="updateEndDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                :items="electronicDevicesWithNull"
                item-text="name"
                item-value="val"
                v-model="electronicDevice"
                label="Blagajna"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="usersWithNull"
                item-text="name"
                item-value="val"
                v-model="user"
                label="Uporabnik"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="localStatus"
                v-model="sessionStatus"
                item-text="name"
                item-value="val"
                label="Status miz v izbranem obdobju"
              >
                <template v-slot:item="{ item }">
                  <div v-if="!item.icon" style="width: 100%;" :class="{ 'd-flex justify-space-between': item.icon !== null }" >
                    <span :style="{ color: item.color }">{{ item.name }}</span>
                    <v-icon v-if="item.icon" :color="item.color"> {{ item.icon }} </v-icon>
                  </div>
                  <button @click.stop="showDeletePopupModal = true" v-else="!item.icon" style="width: 100%;" :class="{ 'd-flex justify-space-between': item.icon !== null }" >
                    <span :style="{ color: item.color }">{{ item.name }}</span>
                    <v-icon v-if="item.icon" :color="item.color"> {{ item.icon }} </v-icon>
                  </button>
                </template>
              </v-select>
            </v-col>
            <v-checkbox
              style="flex: 1;"
              color="#0F998E"
              v-model="localOnlyNegative"
              label="Artikli v minus"
            ></v-checkbox>
          </v-row>
        </v-col>
        <v-col cols="12" md="auto">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="search(false)"
              >
                Išči
                <v-icon right dark>fas fa-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-show="loading">
          <AppSpinner />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-for="session in sessionFilter" :key="session.id">
          <SessionCard
            v-if="narocila[session.id]"
            :session="session"
            :lON="localOnlyNegative"
            :orders="narocila[session.id]"
            @refreshSessions="refreshSessions"
          />
        </v-col>
      </v-row>
    </div>

    <ConfirmDialog
      title="Počisti analitiko miz"
      text="Ali res želite počistiti vso analitiko zaključenih naročil?"
      okBtnText="Nadaljuj"
      v-model="showDeletePopupModal"
      @confirmed="clearTableAnalitics()"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateTimeSelector from '@/components/DateTimeSelector'
import ConfirmDialog from '@/components/ConfirmDialog'
import SessionCard from '@/components/SessionCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    SessionCard,
    ConfirmDialog,
    DateTimeSelector
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      currentInvoice: null,
      electronicDevicesWithNull: [],
      electronicDevice: null,
      invoiceNumber: null,
      usersWithNull: [],
      showDeletePopupModal: false,
      user: null,
      sessionStatus: 0,
      localOnlyNegative: false,
      localStatus: [{
        name: 'Vse začete',
        val: 0
      }/* , {
        name: 'Vse odprte',
        val: 1
      } */, {
        name: 'Vse zaključene',
        val: 2
      }, {
        name: 'Izdan račun',
        val: 3
      }, {
        name: 'Izbrisane',
        val: 4
      }, {
        name: 'Prenesene',
        val: 5
      }, {
        name: 'Drugo',
        val: 6
      }, {
        name: 'Počisti analitiko miz',
        val: 7,
        icon: 'fa-solid fa-trash',
        color: 'red'
      }],
      startDate: '',
      startTime: '00:00',
      endDate: '',
      endTime: '23:59',
      loading: false,
      resolveFunc: null,
      comment: '',
      localSessions: null,
      narocila: null
    }
  },
  computed: {
    devices () {
      return objectToArray(this.$store.state.clientsDevices.items) // .filter(device => device.activation_date !== null)
    },
    businessUnitId () {
      return this.$store.state.businessUnits.currentBusinessUnit.id
    },
    electronicDevices () {
      return Object.values(this.$store.state.devices.items)
    },
    orders () {
      // .sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
      const negArt = (article) => article.quantity < 0
      if (this.localOnlyNegative) {
        const minusOrders = this.$store.state.orders.items
          .filter(order => order.articles.some(negArt))
        return this.$store.state.orders.items
          .filter(order => minusOrders.some(minusOrder => minusOrder.session === order.session))
          .map(order => ({
            ...order,
            payment_amount: order.articles.reduce((prev, curr) => prev + curr.amount, 0).toFixed(2)
          }))
          .reduce((results, curr) => {
            const session = (results[curr.session] || [])
            session.push(curr)
            results[curr.session] = session
            return results
          }, {})
      } else if (this.sessionStatus === 6) {
        const duplicateOrders = this.$store.state.orders.items
          .filter(order => order.reason === 4)
        return this.$store.state.orders.items
          .filter(order => duplicateOrders.some(duplicateOrder => duplicateOrder.session === order.session))
          .map(order => ({
            ...order,
            payment_amount: order.articles.reduce((prev, curr) => prev + curr.amount, 0).toFixed(2)
          }))
          .reduce((results, curr) => {
            const session = (results[curr.session] || [])
            session.push(curr)
            results[curr.session] = session
            return results
          }, {})
      } else {
        // return [ ...this.$store.state.orders.items ]
        return [ ...this.$store.state.orders.openedOrders, ...this.$store.state.orders.items.filter(allord => allord.reason) ]
          .map(order => ({
            ...order,
            payment_amount: order.articles.reduce((prev, curr) => prev + curr.amount, 0).toFixed(2)
          })).reduce((results, curr) => {
            if (curr.session === null && curr.comment) {
              curr.session = curr.comment
              curr.table_name = curr.comment
              curr.id = curr.session
              curr.directCheckout = true
            }
            const session = (results[curr.session] || [])
            session.push(curr)
            if (curr.session !== null) {
              results[curr.session] = session
            }
            /* else if (curr.session === null && curr.comment !== null) {
              results[null] = session
            } */
            return results
          }, {})
      }
    },
    users () {
      return Object.values(this.$store.state.users.items)
    },
    params () {
      return {
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime,
        dateEndFrom: this.endDate,
        dateEndTo: this.endDate,
        type: 'USERS',
        electronicDevice: this.electronicDevice,
        user: this.user ? { id: this.user } : null,
        sessionStatus: this.sessionStatus,
        onlyNegative: this.localOnlyNegative
      }
    },
    sessionFilter () {
      return this.filter()
    },
    dateFrom () {
      return this.startDate
    },
    dateTo () {
      return this.endDate
    }
  },
  methods: {
    ...mapActions('users', { loadUsers: 'loadItems' }),
    ...mapActions('tables', { loadTables: 'loadItems' }),
    ...mapActions('devices', { loadDevices: 'loadItems' }),
    ...mapActions('orders', { loadType1OrdersByDate: 'loadType1OrdersByDate', loadOpenedType1Orders: 'loadOpenedType1Orders' }),
    ...mapActions('sessions', { loadType1SessionsByDate: 'loadType1SessionsByDate', loadOpenedType1Sessions: 'loadOpenedType1Sessions' }),
    ...mapActions('businessUnits', ['deleteTableSessions']),
    refreshSessions () {
      this.search()
    },
    updateStartDateTime ({ date, time }) {
      this.startDate = date
      this.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.endDate = date
      this.endTime = time
    },
    async clearTableAnalitics () {
      await this.deleteTableSessions()
      this.showDeletePopupModal = false
    },
    filter () {
      const params = this.params
      if (params.electronicDevice) {
        /* if (params.sessionStatus === 1) {
          return this.localSessions.filter(session => !session.end_date && session.electronic_device === params.electronicDevice)
        } else if (params.sessionStatus === 2) {
          return this.localSessions.filter(session => session.end_date && session.electronic_device === params.electronicDevice && (session.reason === params.sessionStatus || params.sessionStatus === 0))
        } else {
          return this.localSessions.filter(session => session.electronic_device === params.electronicDevice && (session.reason === params.sessionStatus || params.sessionStatus === 0) && (this.user ? this.user === session.user_account_end : true))
        } */
        if (params.sessionStatus === 0) {
          return this.localSessions.filter(session => session.electronic_device === params.electronicDevice && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 1) {
          return this.localSessions.filter(session => !session.end_date && session.electronic_device === params.electronicDevice && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 2) {
          // return this.localSessions.filter(session => session.end_date && session.electronic_device === params.electronicDevice && (this.user ? this.user === session.user_account_end : true))
          return this.localSessions.filter(session => session.end_date && session.electronic_device === params.electronicDevice && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 3) {
          return this.localSessions.filter(session => session.end_date && session.reason === 1 && session.electronic_device === params.electronicDevice && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 4) {
          return this.localSessions.filter(session => session.end_date && session.reason === 2 && session.electronic_device === params.electronicDevice && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 5) {
          return this.localSessions.filter(session => session.end_date && session.reason === 3 && session.electronic_device === params.electronicDevice && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 6) {
          return this.localSessions.filter(session => session.end_date && session.reason === 4 && session.electronic_device === params.electronicDevice && (this.user ? this.user === session.user_account_end : true))
        } else {
          return this.localSessions.filter(session => (this.user ? this.user === session.user_account_end : true) && session.electronic_device === params.electronicDevice)
        }
      } else {
        if (params.sessionStatus === 0) {
          return this.localSessions.filter(session => (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 1) {
          return this.localSessions.filter(session => !session.end_date && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 2) {
          // return this.localSessions.filter(session => session.end_date && (this.user ? this.user === session.user_account_end : true))
          return this.localSessions //.filter(session => session.end_date && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 3) {
          return this.localSessions.filter(session => session.end_date && session.reason === 1 && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 4) {
          return this.localSessions.filter(session => session.end_date && session.reason === 2 && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 5) {
          return this.localSessions.filter(session => session.end_date && session.reason === 3 && (this.user ? this.user === session.user_account_end : true))
        } else if (params.sessionStatus === 6) {
          return this.localSessions.filter(session => session.end_date && session.reason === 4 && (this.user ? this.user === session.user_account_end : true))
        } else {
          return this.localSessions.filter(session => (this.user ? this.user === session.user_account_end : true))
        }
      }
    },
    sessions (openedToo = false) {
      const order = { true: 1, null: 2, false: 3 };
      if  (!this.localOnlyNegative) {
        var newSessions = []
        if (this.sessionStatus !== 6) {
                                                                                // ignore the opened sessiosn, as we already get them
          if (openedToo) {
            newSessions = [ ...this.$store.state.sessions.openedSessions, ...this.$store.state.sessions.items.filter(allses => allses.reason) ]
          } else {
            if (this.sessionStatus !== 0) {
              newSessions = [ ...this.$store.state.sessions.items.filter(allses => allses.reason) ]
            } else {
              newSessions = [ ...this.$store.state.sessions.items ]
            }
          }
        } else {
          const ordersDuplicated = this.$store.state.orders.items
          .filter(order => order.reason === 4)
          const dupOrderExist = (session) => ordersDuplicated.find(order => order.session === session.id)
          newSessions = this.$store.state.sessions.items.filter(dupOrderExist)
        }
        const directOrders = Object.values(this.orders).filter(a => a[0].directCheckout).map(b => b[0])
        const sesssh = [ ...newSessions, ...directOrders ]
        if (this.localStatus === 0) {
          return sesssh.sort((a, b) => {
            var sortedB = this.orders[b.id] ? this.orders[b.id].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0] || null : null // eslint-disable-line
            var sortedA = this.orders[a.id] ? this.orders[a.id].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0] || null : null // eslint-disable-line
            if (sortedB && sortedB.start_date && sortedA && sortedA.start_date) {
              return (new Date(sortedB.start_date) - new Date(sortedA.start_date)) // eslint-disable-line
            } else {
              return 1
            }
          }).sort((a, b) => {
            return (order[b.end_date !== null] - order[a.end_date !== null])
          })
        } else {
          const liveSesssh = sesssh.filter(s => !s.reason)
          const endSesssh = sesssh.filter(s => s.reason)

          const liveSort = liveSesssh.length > 0 ? liveSesssh.sort((a, b) => {
            var sortedB = this.orders[b.id] ? this.orders[b.id].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0] || null : null // eslint-disable-line
            var sortedA = this.orders[a.id] ? this.orders[a.id].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0] || null : null // eslint-disable-line
            if (sortedB && sortedB.start_date && sortedA && sortedA.start_date) {
              console.log(new Date(sortedB.start_date), new Date(sortedA.start_date))
              return (new Date(sortedB.start_date) - new Date(sortedA.start_date)) // eslint-disable-line
            } else {
              return 1
            }
          }).sort((a, b) => {
            return (order[b.end_date !== null] - order[a.end_date !== null])
          }) : []

          return [ ...liveSort, ...endSesssh.sort((a, b) => {
            var sortedB = this.orders[b.id] ? this.orders[b.id].sort((a, b) => new Date(b.end_date) - new Date(a.end_date))[0] || null : null // eslint-disable-line
            var sortedA = this.orders[a.id] ? this.orders[a.id].sort((a, b) => new Date(b.end_date) - new Date(a.end_date))[0] || null : null // eslint-disable-line
            if (sortedB && sortedB.end_date && sortedA && sortedA.end_date) {
              return (new Date(sortedB.end_date) - new Date(sortedA.end_date)) // eslint-disable-line
            } else {
              return 1
            }
          }).sort((a, b) => {
            return (order[b.end_date !== null] - order[a.end_date !== null])
          }) ]
        }
      } else {
        const negArt = (article) => article.quantity < 0
        const ordersNegated = this.$store.state.orders.items
          .filter(order => order.articles.some(negArt))

        const negOrderExist = (session) => ordersNegated.find(order => order.session === session.id)

        return this.$store.state.sessions.items.filter(negOrderExist)
        .sort((a, b) => {
          var sortedB = this.orders[b.id] ? this.orders[b.id].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0] || null : null // eslint-disable-line
          var sortedA = this.orders[a.id] ? this.orders[a.id].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0] || null : null // eslint-disable-line
          if (sortedB && sortedB.start_date && sortedA && sortedA.start_date) {
            return (new Date(sortedB.start_date) - new Date(sortedA.start_date)) // eslint-disable-line
          } else {
            return 1
          }
        }).sort((a, b) => {
          return (order[b.end_date !== null] - order[a.end_date !== null])
        })
      }
    },
    /* filter using utton */
    async search (openedToo = false) {
      this.loading = true
      this.localSessions = []
      this.narocila = []
      const params = this.params
      if (this.sessionStatus == 0 || this.sessionStatus == 1) {
        await this.loadType1SessionsByDate({ dateFrom: `${params.startDate}T${params.startTime}:00`, dateTo: `${params.endDate}T${params.endTime}:00` }) // eslint-disable-line
        await this.loadType1OrdersByDate({ dateFrom: `${params.startDate}T${params.startTime}:00`, dateTo: `${params.endDate}T${params.endTime}:00` }) // eslint-disable-line
      } else {
        await this.loadType1SessionsByDate({ dateEndFrom: `${params.startDate}T${params.startTime}:00`, dateEndTo: `${params.endDate}T${params.endTime}:00`, type: 2 }) // eslint-disable-line
        await this.loadType1OrdersByDate({ dateEndFrom: `${params.startDate}T${params.startTime}:00`, dateEndTo: `${params.endDate}T${params.endTime}:00`, type: 2 }) // eslint-disable-line
      }
      if (openedToo) {
        await this.loadOpenedType1Sessions() // eslint-disable-line
        await this.loadOpenedType1Orders() // eslint-disable-line
      }
      this.localSessions = this.sessions(openedToo)
      this.narocila = this.orders
      this.loading = false
      return Promise.resolve(true)
    }
  },
  async created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      // const yesterday = moment().add(-1, 'days').format('YYYY-MM-DD')
      // const yesterday = moment().add(-1, 'days').format('YYYY-MM-DD')
      const today = moment().format('YYYY-MM-DD')
      this.startDate = today
      this.endDate = today
      await this.loadUsers() // eslint-disable-line
      await this.loadDevices() // eslint-disable-line
      await this.loadTables()
      this.electronicDevicesWithNull.push({
        name: 'Vse naprave',
        val: null
      })
      this.electronicDevices.forEach(device => {
        this.electronicDevicesWithNull.push({
          name: `${device.name} (${device.electronic_device_id})`,
          val: device.id
        })
      })
      this.usersWithNull.push({
        name: 'Vsi uporabniki',
        val: null
      })
      this.users.forEach(user => {
        let name = user.moniker
        if (user.complete_name) {
          name += ` - ${user.complete_name}`
        }
        this.usersWithNull.push({
          name,
          val: user.id
        })
      })
      this.search(true)
      this.asyncDataStatus_fetched()
       /*  .catch(anErr => {
          // console.log(anErr)
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri nalaganju podatkov.'
          })
        }) */
    }
  },
  watch: {
    sessionStatus (val) {
      this.localSessions = []
    }
  }
}

</script>

<style lang="scss" scoped>
.print-a4-invoice {
  display: none;
}
@media print {
  .print-a4-invoice {
    display: block;
  }
}
</style>

<style lang="scss">
@media print {
  .cms,
  .header,
  .v-navigation-drawer,
  .footer {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
}
</style>
